/** @jsx jsx */
import IconChevronDown from '@apollo/icons/default/IconChevronDown.svg';
import IconChevronUp from '@apollo/icons/default/IconChevronUp.svg';
import IconErrorSolid from '@apollo/icons/default/IconErrorSolid.svg';
import { css, jsx } from '@emotion/react';
import classnames from 'classnames';
import { useState } from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';
import { format } from 'src/lib/format';
import { ContractVariantFailedStep } from 'src/lib/graphqlTypes/types';

export const ContractErrorsBanner = ({
  errors,
  failedAt,
}: {
  errors: string[];
  failedAt: ContractVariantFailedStep;
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(errors.length === 1);
  return (
    <div
      className="rounded border border-red-light bg-red-lightest"
      css={css`
        /* For Firefox */
        * {
          scrollbar-width: thin;
          scrollbar-color: #f18686;
        }

        /* For Chrome, Edge, and Safari */
        *::-webkit-scrollbar {
          width: 6px;
        }

        *::-webkit-scrollbar-track {
          background-color: transparent;
          margin-top: 10px;
          margin-bottom: 10px;
        }

        *::-webkit-scrollbar-thumb {
          background-color: #f18686;
          border-radius: 12px;
        }
      `}
    >
      <div
        className={classnames(
          'flex items-center justify-between rounded-t bg-red-lighter p-2 px-4 text-base text-red-darker',
          {
            'border-b border-red-light': isOpen,
          },
        )}
      >
        <div className="flex">
          <Tooltip label={`Failed @ ${failedAt}`}>
            <IconErrorSolid className="m-auto mr-2 rounded-full bg-white text-icon-error" />
          </Tooltip>
          The current filter configuration resulted in&nbsp;
          <b>
            {errors.length} {format.pluralize(errors.length, 'error')}.
          </b>
        </div>
        <div className="mr-2 cursor-pointer" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? (
            <Tooltip
              label={`Collapse ${format.pluralize(errors.length, 'error')}`}
            >
              <IconChevronUp className="text-red-dark" />
            </Tooltip>
          ) : (
            <Tooltip label={`Show ${format.pluralize(errors.length, 'error')}`}>
              <IconChevronDown className="text-red-dark" />
            </Tooltip>
          )}
        </div>
      </div>
      {isOpen && (
        <div className="mx-6 max-h-28 min-h-full space-y-4 overflow-auto py-2 text-red-darker">
          {errors.map((e) => (
            <div
              key={e}
              className="border-l-2 border-red-lighter pl-4 font-mono text-sm"
            >
              {e}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
